import { render, staticRenderFns } from "./imagewall.vue?vue&type=template&id=dcbe1a56&scoped=true&"
import script from "./imagewall.vue?vue&type=script&lang=js&"
export * from "./imagewall.vue?vue&type=script&lang=js&"
import style0 from "./imagewall.vue?vue&type=style&index=0&id=dcbe1a56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbe1a56",
  null
  
)

export default component.exports